<template>
  <div :class="$style['tapes']">
    <NuxtLink to="/kaartverkoop" :class="$style['tape']" :aria-label="`Kaarten voor ${show.title}${show.whenLong ? `, ${show.whenLong}` : ''}`">
      <span :class="$style['tape__track']" aria-hidden="true">
        <template v-for="copy in 2" :key="copy">
          <template v-for="line in lines" :key="`${copy}-${line}`">
            <span>{{ line }}</span>
            <SiteMark />
          </template>
        </template>
      </span>
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
// An amber tape across the end of every page that runs to the tickets
const show = await useShow()
const lines = computed(() => [show.title, show.whenLong, 'Kaarten via Schouwburg Hengelo'].filter(Boolean))
</script>
<style module>
/* Clips the tilted tape, so the page does not scroll sideways */
.tapes {
  overflow: hidden;
  margin-top: var(--stage-rhythm);
  padding-block: var(--spacing-xxxl) var(--spacing-l);
}

.tape {
  display: block;
  overflow: hidden;
  padding-block: clamp(0.9rem, 0.6rem + 0.8vw, 1.5rem);
  background: var(--primary-color);
  color: var(--stage-black);
  text-decoration: none;
  transform: rotate(-2deg) scale(1.05);
  box-shadow: 0 1.5rem 3rem oklch(0% 0 0deg / 50%);
  transition: background-color 250ms;
}

.tape:hover {
  background: var(--stage-white);
  color: var(--stage-black);
}

.tape:focus-visible {
  outline: 0.1875rem solid var(--stage-white);
  outline-offset: 0.25rem;
}

.tape__track {
  display: flex;
  align-items: center;
  gap: 0.6em;
  width: max-content;
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  font-size: clamp(1.5rem, 1rem + 2.2vw, 3.25rem);
  line-height: 1;
  letter-spacing: -0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  animation: tape-run 40s linear infinite;
}

.tape:hover .tape__track {
  animation-play-state: paused;
}

@keyframes tape-run {
  to { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .tape {
    transition: none;
  }

  .tape__track {
    animation: none;
  }
}
</style>
